// extracted by mini-css-extract-plugin
module.exports = {"questionSet":"QuestionSet_questionSet__qcOTu","questionList":"QuestionSet_questionList__290qs"};